import { useGetChatroom } from '@pba/react-chat-core';
import { createChatroom } from 'models';
import { useMemo } from 'react';

type P = {
  id: string;
};

export const useChatroomQuery = ({ id }: P) => {
  const query = useGetChatroom({ filter: { id } });

  const data = useMemo(() => (query.data ? createChatroom(query.data) : null), [query.data]);

  return useMemo(
    () => ({
      ...query,
      data,
    }),
    [data, query],
  );
};
